/**
 * Treasure Ledger — each team's final holdings, for paying out after the game.
 *
 * These are POST-THEFT totals: the snapshot replays Treasure Thief through the
 * same `computeTrlTeamHauls` the player's own haul panel uses, so what an admin
 * pays out and what a team was told it holds cannot disagree. The raw award
 * rows are gross and would over-pay a team that was robbed.
 */

import { TrlTreasureRows } from '@swtorbit/shared-components';
import type { TrlTeamTreasureStat } from '@swtorbit/shared-socket-events';
import { resolveServerUrl } from '../../../utils/serverUrl';
import { StatCard } from './StatCard';

export function TrlTreasureLedgerCard({ treasure }: { treasure: TrlTeamTreasureStat[] }) {
  const anyHaul = treasure.some((t) => t.rows.length > 0);

  return (
    <StatCard
      title="Treasure Ledger"
      icon="💎"
      summary="after theft"
      isEmpty={!anyHaul}
      emptyMessage="No treasure was awarded in this game."
    >
      <div className="d-flex flex-column gap-sm">
        {treasure.map((team) => (
          <div key={team.teamId} className="d-flex flex-column gap-2xs">
            <div className="d-flex align-items-center gap-xs flex-wrap">
              <span className="text-white">{team.teamName}</span>
              <span className="fs-xs text-slate">
                {team.primaryWins} first place{team.primaryWins === 1 ? '' : 's'}
                {team.consolationWins > 0 && ` · ${team.consolationWins} runner-up`}
              </span>
            </div>
            {team.rows.length > 0 ? (
              <TrlTreasureRows
                rows={team.rows.map((row) =>
                  row.icon.kind === 'cartel' && row.icon.url
                    ? { ...row, icon: { ...row.icon, url: resolveServerUrl(row.icon.url) } }
                    : row,
                )}
              />
            ) : (
              <span className="fs-sm text-cyan ps-sm">
                Holding nothing — everything won was stolen.
              </span>
            )}
          </div>
        ))}
      </div>
    </StatCard>
  );
}
